import type { IMultiSelectOption } from '@frontend/pole-ui/lib/components/MultiSelect'
import { useData } from '@/logic/data'
import type { IRegion } from '@/types'
import { EFinancingProductId } from '@/types'
import { useRegionsMicrocreditOrganizations } from '@/utils/hooks/applyingFinancingOffer/useRegionsMicrocreditOrganizations'

export const useGetAgentRegions = () => {
  const { data: regionsData = [] } = useData<IRegion[]>('regions')

  const { regionsAvailableExpressMFO } = useRegionsMicrocreditOrganizations({
    productId: EFinancingProductId.EXPRESS_MFO,
  })

  const filteredRegions: IMultiSelectOption[] = regionsData
    .filter(region => regionsAvailableExpressMFO.includes(region.code))
    .map(region => ({
      label: region.name,
      value: String(region.code),
    }))

  return { filteredRegions, regionsData }
}
